import * as angular from 'angular';

import { IRequestService } from '../../services';
import { ThermoPackage, ThermoPackageDto } from '../../models';

export interface IThermoPackageService {
    getAll(): angular.IPromise<ThermoPackageDto[]>;
    getByName(name: string): angular.IPromise<ThermoPackageDto>;
    update(thermoPackage: ThermoPackage): angular.IPromise<number>;
}

export class ThermoPackageService implements IThermoPackageService {
    static serviceId = 'thermoPackageService';

    private _controllerUrl: string;

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    private controllerUrl() {
        if (!this._controllerUrl) {
            this._controllerUrl = this._requestService.getUrlV1() + 'thermoPackage/';
        }
        return this._controllerUrl;
    }

    getAll(): angular.IPromise<ThermoPackageDto[]> {
        const url = this.controllerUrl();
        return this._requestService.get(url);
    }

    getByName(name: string): angular.IPromise<ThermoPackageDto> {
        const url = this.controllerUrl() + '?name=' + name;
        return this._requestService.get(url);
    }

    update(thermoPackage: any): angular.IPromise<number> {
        const url = this.controllerUrl() + 'update/';
        const cleanUrl = this.controllerUrl() + '?name=' + thermoPackage.name;
        this._requestService.cleanCache(cleanUrl);
        return this._requestService.post(url, thermoPackage);
    }
}